import { ultimosItens, asyncTimeOut, clone } from '@/service/util'
import { permiteAction } from '@/service/acao'
import store from '../index'

import * as pedido from '@/api/pedido'
import * as cidadeuf from '@/api/cidadeuf'
import * as usuario from '@/api/usuario'
import * as produto from '@/api/produto'
import * as instituicao from '@/api/instituicao'
import * as banco from '@/api/banco'
import * as listagem from '@/api/listagem'
import * as contrato from '@/api/contrato'
import * as saldos from '@/api/saldos'
import * as especies from '@/api/especies'
import * as filas from '@/api/filas'
import * as featureToggle from '@/api/feature_toggle'

function listProduto (lista) {
  const tratada = []
  lista.forEach(el => {
    if (el.produtos.length > 0) tratada.push(...listProduto(el.produtos))
    tratada.push(el)
  })
  return tratada
}

function guardaValidouSenha () {
  localStorage.setItem('comissoes', true)
}

function getValidouSenha () {
  return JSON.parse(localStorage.getItem('comissoes'))
}

const state = {
  origensTree: {
    active: false,
    list: []
  },
  assinatura: {
    active: false,
    html: []
  },
  produto: {
    active: false,
    tree: [],
    list: [],
    front: [],
    novoProdutoModal: false
  },
  produtotabela: [],
  listagemGrupo: {
    active: false,
    list: []
  },
  instituicoes: [],
  instituicaoproduto: [],
  instituicoestabela: [],
  mostraComissao: true,
  validouSenhaComissao: false,
  modalImprimeContratos: false,
  pacotes: [],
  consignaveis: [],
  bancos: [],
  triggerGetProdutos: false,
  saldoExtrato: 0,
  saldoHigienizacaoAssertiva: 0,
  modalSenhaComissao: false,
  saldoIN100: 0,
  parceiro: false,
  tiposConsulta: [
    {value: 'cpf', label: 'CPF'},
    {value: 'cnpj', label: 'CNPJ'},
    {value: 'nome', label: 'NOME'},
    {value: 'email', label: 'EMAIL'},
    {value: 'telefone', label: 'TELEFONE'}
  ]
}

const getters = {
  origensPrincipalSecundaria: state => {
    const result = { principal: [], secundario: [] }
    if (!state.origensTree.active) return result
    ultimosItens(state.origensTree.list, 'origens').forEach(elem => {
      if (elem.principal) return result.principal.push(elem)
      return result.secundario.push(elem)
    })
    return result
  }
}

const mutations = {
  SETORIGENSTREE (state, payload) {
    state.origensTree.active = true
    state.origensTree.list = payload
  },
  ASSINATURAUSUARIO (state, { html }) {
    state.assinatura.active = true
    state.assinatura.html = html
  },
  SETPRODUTO (state, payload) {
    state.produto.active = true
    state.produto.tree = clone(payload)
    state.produto.list = listProduto(payload)
    state.produto.front = payload[0].produtos
  },
  PRODUTOCTABELA (state, payload) {
    state.produtotabela = payload
  },
  PRODUTOCCONTRATO (state, payload) {
    state.produtocontrato = payload
  },
  SETLISTAGEMGRUPO (state, payload) {
    state.listagemGrupo.active = true
    state.listagemGrupo.list = payload
  },
  NOVOPRODUTOMODAL (state, payload) {
    state.produto.novoProdutoModal = payload
  },
  INSTITUICOES (state, payload) {
    state.instituicoes = payload
  },
  INSTITUICOESBYPRODUTO (state, payload) {
    state.instituicaoproduto = payload
  },
  INSTITUICAOCTABELA (state, payload) {
    state.instituicoestabela = payload
  },
  INSTITUICAOCCONTRATRO (state, payload) {
    state.instituicoescontrato = payload
  },
  BANCOS (state, payload) {
    state.bancos = payload
  },
  TMCOMISSAO (state, payload) {
    state.mostraComissao = payload || false
  },
  VALIDOUSENHACOMISSAO (state, payload) {
    state.validouSenhaComissao = payload
  },
  MOSTRAIMPRIMECONTRATOS (state, payload) {
    state.modalImprimeContratos = payload
  },
  SETSALDOS (state, payload) {
    state.pacotes = payload
  },
  ESPECIESCONSIGNAVEIS (state, payload) {
    state.consignaveis = payload
  },
  SETTRIGGERGETPRODUTOS (state) {
    state.triggerGetProdutos = !state.triggerGetProdutos
  },
  SETSALDOEXTRATO (state, payload) {
    state.saldoExtrato = payload
  },
  SETSALDOIN100 (state, payload) {
    state.saldoIN100 = payload
  },
  SETSALDOEXTRATOHIGIENIZACAOASSERTIVA (state, payload) {
    state.saldoHigienizacaoAssertiva = payload
  },
  MODALSENHACOMISSAO (state, payload) {
    state.modalSenhaComissao = payload
  },
  SETPARCEIRO (state, payload) {
    state.parceiro = payload
  }
}

const actions = {
  async buscaOrigensTree ({ state, commit }) {
    if (!state.origensTree.active) {
      commit('SETORIGENSTREE', await pedido.origemTree())
    }
  },
  async filtraCidades (context, payload) {
    if (payload !== '' && payload !== undefined && payload !== null && payload.length > 2) {
      await asyncTimeOut('filtraCidades')
      const { list } = await cidadeuf.listCidadesFiltro(payload)
      return list
    } else {
      return []
    }
  },
  async getAssinatura ({ state, commit }) {
    if (state.assinatura.active) return state.assinatura.html
    let data = await usuario.assinatura()
    commit('ASSINATURAUSUARIO', data)
    return data.html
  },
  async getAssinaturaEditDados ({ state, commit }) {
    let data = await usuario.assinatura()
    return data.html
  },
  async getProduto ({ state, commit }) {
    if (!state.produto.active) {
      let data = await produto.list()
      commit('SETPRODUTO', data)
    }
  },
  async getProdutoCTabela ({ state, commit }) {
    let data = await produto.cTabela()
    commit('PRODUTOCTABELA', data)
  },
  // produtos com contrato
  async getProdutoCContrato ({ state, commit }) {
    let data = await produto.cContrato()
    commit('PRODUTOCCONTRATO', data)
  },
  async getIdentProduto ({ state }, identificacao) {
    const ind = state.produto.list.findIndex(i => i.identificacao === identificacao)
    if (ind !== -1) return state.produto.list[ind]
    else return {}
  },
  async getInstituicoes ({ commit }, payload) {
    const { list } = await instituicao.list()
    commit('INSTITUICOES', list)
    return list
  },
  async getInstituicoesByProduto ({ commit }, payload) {
    const { list } = await instituicao.byProduto(payload)
    commit('INSTITUICOESBYPRODUTO', list)
    return list
  },
  async getInstituicoesByProdutoReturn ({ commit }, payload) {
    const { list } = await instituicao.byProduto(payload)
    return list
  },
  async getInstituicoesByFiltro (context, payload) {
    const { list } = await instituicao.listFiltro(payload)
    return list
  },
  async getInstituicoesCTabela ({ commit }, payload) {
    const list = await instituicao.cTabela()
    commit('INSTITUICAOCTABELA', list)
  },
  async getInstituicoesCTabelaFiltro ({ commit }, payload) {
    const list = await instituicao.cTabelaFiltro(payload)
    commit('INSTITUICAOCTABELA', list)
  },
  // instituicoes q tenham contrato
  async getInstituicoesCContrato ({ commit }, payload) {
    const list = await instituicao.cContrato({produto_id: payload})
    commit('INSTITUICAOCCONTRATRO', list)
  },
  async getBancos ({ commit }, payload) {
    const { list } = await banco.list()
    commit('BANCOS', list)
    return list
  },
  async getListagemGrupos ({ state, commit }, payload) {
    if (state.listagemGrupo.active) return state.listagemGrupo.list
    let list = await listagem.usuarioGrupos()
    commit('SETLISTAGEMGRUPO', list)
    return list
  },
  async getListagens ({ state, commit }, payload) {
    let list = await listagem.usuarioListagem(payload) || []
    list = list.map(e => ({ id: e.id, nome: e.campanha.nome }))
    return list
  },
  async getListagensUsuario ({ state, commit }, payload) {
    let list = await listagem.usuarioListagens(payload) || []
    list = list.map(e => ({ id: e.id, nome: e.campanha.nome }))
    return list
  },
  async getContratos ({ commit }, payload) {
    let contratos = await contrato.listByProdutoInstituicao(payload)
    return contratos.list
  },
  novoProdutoModal ({ commit }, payload) {
    commit('NOVOPRODUTOMODAL', payload)
  },
  tMComissao ({ commit }, payload) {
    commit('TMCOMISSAO', payload)
  },
  mostraImprimeContratos ({ state, commit }, payload) {
    commit('MOSTRAIMPRIMECONTRATOS', payload)
  },
  async getSaldos ({commit}) {
    let dados = await saldos.get()
    let pacotes = dados.instancia
    commit('SETSALDOS', pacotes)
    let pacote = pacotes.find(p => p.tipo_id === 12)
    let saldo = !pacote ? 0 : pacote.saldo_atual
    commit('SETSALDOEXTRATOHIGIENIZACAOASSERTIVA', saldo)
    pacotes.forEach(pacote => {
      if (pacote.tipo_id === 11) commit('SETSALDOEXTRATO', pacote.saldo_atual)
    })
    pacotes.forEach(pacote => {
      if (pacote.tipo_id === 13) commit('SETSALDOIN100', pacote.saldo_atual)
    })
  },
  async especiesConsignaveis ({ commit }) {
    commit('ESPECIESCONSIGNAVEIS', await especies.getConsignaveis())
  },
  actionTriggerGetProdutos ({ commit }) {
    commit('SETTRIGGERGETPRODUTOS')
  },
  verificaFilaRedis ({ commit }, payload) {
    return filas.verificaFila({ chave: payload })
  },
  async getEndpointFeature ({ commit }, payload) {
    let endpoint = null
    try {
      endpoint = await featureToggle.buscarEndpoint(payload)
      endpoint = endpoint.instancia
    } catch (error) {
      console.error('Erro feature toggle ' + JSON.stringify(payload), error.message)
    }

    return endpoint
  },
  toggleModalSenhaComissao ({commit, state}) {
    commit('MODALSENHACOMISSAO', !state.modalSenhaComissao)
  },
  async mostrarComissao ({commit, state}) {
    let validou = await getValidouSenha()
    if (permiteAction('visualizar_comissoes_senha') && !validou) {
      commit('MODALSENHACOMISSAO', true)
    } else commit('TMCOMISSAO', !state.mostraComissao)
  },
  async validaSenhaComissao ({ commit }, payload) {
    let envelope = await usuario.validaSenhaComissao(payload)
    let data = envelope.instancia
    if (data) {
      commit('TMCOMISSAO', true)
      commit('VALIDOUSENHACOMISSAO', true)
      guardaValidouSenha()
    }
    return data
  },
  async getValidouSenhaComissao ({ commit }, payload) {
    let validou = await getValidouSenha()
    if (validou) {
      commit('TMCOMISSAO', true)
      commit('VALIDOUSENHACOMISSAO', true)
    } else if (!permiteAction('visualizar_comissoes')) commit('TMCOMISSAO', false)
  },
  verificaParceiro: function ({ commit }) {
    if (store.state.auth.usuario.parceiro) commit('SETPARCEIRO', store.state.auth.usuario.parceiro.nome.toLowerCase())
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/informacoes.js